<template>
  <div class="flex flex-wrap items-start sm:flex-nowrap">
    <DjImage
      :src="getCartProductVariantImageLink(cartLine.product) ?? cartLine.product.mainPictureUrl"
      :width="100"
      :height="100"
      :alt="getCartProductVariantName(cartLine.product) ?? cartLine.product.name"
      class="brightness-[98%] dj-product-image-small w-10 h-10 sm:w-12 sm:h-12"
    />
    <div class="flex-1 pl-2 w-[150px]">
      <NuxtLink
        :to="localePath(`/product/${cartLine.product.productVariant.skuProduct}`)"
        class="product-card"
      >
        <h3 class="truncate">
          {{ getCartProductVariantName(cartLine.product) ?? cartLine.product.name }}
        </h3>
      </NuxtLink>
      <p class="">
        {{ getCartProductVariantSku(cartLine.product) ?? cartLine.product.sku }}
      </p>
      <div class="flex items-center">
        <span class="dj-product-ref">
          {{ getCartSupplierName(cartLine.product) ?? cartLine.product.supplier }}
        </span>
      </div>
    </div>
  </div>
  <div class="flex items-center h-12">
    <div class="w-[80px]">
      <DjQuantity
        :model-value="cartLine.quantity"
        disabled
        :min="Math.max(cartLine.product.offer.itemPerPack, cartLine.product.offer.minOrderQuantity)"
        :max="
          Math.min(
            cartLine.product.offer.maxOrderQuantity ?? 100000000,
            cartLine.product.offer.stock
          )
        "
        :step="cartLine.product.offer.itemPerPack"
        icon="djust-icon:box-gray"
        class="w-[80px]"
        @update:model-value="(newQuantity: number) => updateQuantity(cartLine.id, newQuantity)"
      />
    </div>
    <div class="ml-2 w-[55px]">
      <span class="mr-1">{{ cartLine.priceHT }}</span>
    </div>
    <UButton
      :key="cartLine.id"
      icon="i-heroicons-x-mark"
      :disabled="isDeleting"
      :loading="isDeleting"
      variant="ghost"
      class="w-5 h-5 text-gray-400 p-0"
      @click="handleDeleteCartLine(cartId, getCartOfferId(cartLine.product), cartLine.id)"
    />
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    cartLine: any;
  }>();
  const { getUserCurrency } = useUser();
  const currency = computed(() => getUserCurrency());
  const emit = defineEmits(['deleted', 'error']);
  const cartStore = useCartStore();
  const cart = computed(() => cartStore.cart);
  const cartId = computed(() => getCartId(cart.value));
  const isDeleting = ref(false);
  const localePath = useLocalePath();
  const {
    getCartId,
    deleteCartLines,
    getCartOfferId,
    addOrUpdateCartLine,
    getCartSupplierName,
    getCartProductVariantName,
    getCartProductVariantImageLink,
    getCartProductVariantSku,
  } = useCart();
  async function updateQuantity(index: number, newQuantity: number) {
    const lineToUpdate = [
      {
        offerPriceId: props.cartLine.offerPriceId,
        quantity: newQuantity,
        updateAction: 'REPLACE_QUANTITY' as UpdateCartLineType,
      },
    ];
    try {
      const response = await addOrUpdateCartLine({
        currency: currency.value,
        cartId: cartId.value,
        typeId: 'offerPriceId',
        lines: lineToUpdate,
      });
    } catch (error) {
      console.error('Error updating cart line quantity:', error);
      // Optionally, notify the user of the error
      //showNotification('Error updating cart quantity. Please try again.', 'error');
    }
  }
  async function handleDeleteCartLine(cartId: string, lineIdToDelete: string, index: number) {
    try {
      isDeleting.value = true;
      const response = await deleteCartLines({
        cartId: cartId,
        lineIdsToDelete: [lineIdToDelete],
      });
      emit('deleted', response);
    } catch (error) {
      console.error('Failed to delete cart lines:', error);
      emit('error', error);
    } finally {
      isDeleting.value = false;
    }
  }
</script>

<style lang="scss"></style>
